import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonMenuButton, IonNote, IonPage, IonRadio, IonRadioGroup, IonRow, IonSelect, IonSelectOption, IonText, IonTextarea, IonTitle, IonToolbar, useIonAlert, useIonLoading, useIonRouter, useIonToast, useIonViewWillEnter } from '@ionic/react';
import { addCircleOutline, locationOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../AppProvider';

const PlaceCreate: React.FC = () => {     
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const [infoVisible, setInfoVisible] = useState<boolean>(false);
    const [placeTimezone, setPlaceTimezone] = useState<string>('');

    const phoneInputRef = useRef<any>();
    const router = useIonRouter();

    const { networkStatus, getAppStatus, authKey, authenticateMember, setShowLoader, limits, profiles, settings, userIANATimezone, timezonesIANA, countries, getTimezonesIANA, getCountries, SWFullHorizLogo, SWTextDarkLogo, showToast, present, dismiss } = useAppContext();
    
    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => {
        //setShowLoader(true); 
        const authenticate = async () => {
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();         
                if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
                else {
                    if (countries.length === 0) await getCountries();
                    if (timezonesIANA.length === 0) await getTimezonesIANA(); 
                    //setShowLoader(false);
                }
            }
        };
        authenticate();
    }); 
    
    useEffect(() => {
        setPlaceTimezone(userIANATimezone);
    }, [userIANATimezone]);    

    const formatPhone = () => {
        const refVal = phoneInputRef.current.value;
        const formattedValue = refVal.replace(/\D/g,'');
        phoneInputRef.current.value = formattedValue;
    };

    const toggleInfoContent = () => setInfoVisible(!infoVisible);

    const toggleAlertContent = () => setAlertVisible(!alertVisible);

    const insertPlace = async (e: any) => {
        e.preventDefault();
        await present('Saving Place...');
        const form = e.target; 
        const formName = form.name;
        const btn: any = document.getElementById(formName + 'Submit');
        btn.innerHTML = 'Saving...';
        btn.setAttribute('disabled', '');
        const formData = new FormData(form);
        formData.append('mt', authKey.mt);
        
        try {
            const response = await fetch('https://api.besolowise.com/places/insert/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json(); 
                
                if(obj.success) {
                    dismiss();
                    router.push('/account/place/edit/' + obj.pt, 'back');
                } else {
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                    dismiss();
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 5000,
                        color: 'danger',
                    });
                }
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                dismiss();
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 3000,
                    color: 'danger',
                });
            } 
        } catch(error) {
            dismiss();
            showToast({
                message: 'Connection Error: Couldn\'t create this place. ' + error + '. Try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }       
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerLink='/account/places'>Places</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className='headerTextLogo' src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg">
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon color={'secondary'} icon={locationOutline}></IonIcon> New Place<br /><span>Save details about your favorite locations</span></h1>
                        </IonCol>
                    </IonRow>
                </IonGrid>

                {profiles?.places >= limits?.places &&
                    <IonCard>
                        <IonCardHeader>
                            <IonCardTitle className='ion-margin-bottom ion-text-center' color={'tertiary'}>
                                You've reached the limit of Places for your current plan.
                            </IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <p className='ion-margin-bottom ion-text-center'>
                                You can add more Places by upgrading to a SoloWise Premium plan. 
                            </p>
                            <p className='ion-margin-bottom ion-text-center'>                            
                                <IonButton className='ion-margin' color={'secondary'} routerLink='/account/plans' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Upgrade Now</IonButton>
                            </p>
                        </IonCardContent>
                    </IonCard>
                } 

                {profiles?.places < limits?.places &&
                <IonCard>
                    <IonCardContent>
                        <form name='placeForm' onSubmit={insertPlace}>
                            <IonGrid>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Place Name</b></IonLabel> <em className='required'>Required</em><br />
                                        <IonNote>Examples: "Home", "Work", "Some Trailhead"</IonNote>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput autocapitalize='sentences' counter fill='outline' name='placeName' placeholder='' type='text' maxlength={50}></IonInput>                                        
                                    </IonCol>                                  
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Timezone</b></IonLabel> <em className='required'>Required</em>
                                    </IonCol>
                                    <IonCol sizeXs='12'>
                                        <IonSelect fill='outline' labelPlacement='stacked' name='placeTimezone' placeholder='Select a Timezone' value={userIANATimezone}>
                                            {timezonesIANA.map((zone: any, index: number) => (
                                                <IonSelectOption key={index} value={zone['iana']}>{zone['label']}</IonSelectOption>
                                            ))}                                              
                                        </IonSelect>
                                    </IonCol> 
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Address / Location</b></IonLabel> <em className='required'>Required</em><br />
                                        <IonNote>This can be a Street Address, GPS Coordinates, or just a good description.</IonNote>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonTextarea autoCapitalize='sentences' autoGrow={true} fill='outline' name='placeLocation' placeholder=''></IonTextarea>                               
                                    </IonCol>
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Property and Environment</b></IonLabel>
                                    </IonCol>
                                    <IonCol sizeXs='12' sizeSm='6'>                                           
                                        <IonSelect fill='outline' label='Type of Property' labelPlacement='stacked' name='placePropertyType' placeholder='Select'>
                                            <IonSelectOption value=''>Unknown</IonSelectOption>
                                            <IonSelectOption value='Public'>Public</IonSelectOption> 
                                            <IonSelectOption value='Private'>Private</IonSelectOption>                      
                                        </IonSelect>
                                    </IonCol>
                                    <IonCol sizeXs='12' sizeSm='6'>
                                        <IonSelect fill='outline' label='Type of Environment' labelPlacement='stacked' name='placeEnvType' placeholder='Select'>
                                            <IonSelectOption value=''>Unknown</IonSelectOption>
                                            <IonSelectOption value='Urban'>Urban</IonSelectOption>
                                            <IonSelectOption value='Suburban'>Suburban</IonSelectOption> 
                                            <IonSelectOption value='Rural'>Rural</IonSelectOption>
                                            <IonSelectOption value='Wilderness'>Wilderness</IonSelectOption>                        
                                        </IonSelect>
                                    </IonCol>                               
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Google Maps Link</b></IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonTextarea autoGrow={true} fill='outline' name='placeMapLink' placeholder=''></IonTextarea>                              
                                    </IonCol>
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Landline Phone</b></IonLabel>
                                    </IonCol>
                                    <IonCol sizeXs='12' sizeSm='6'>
                                        <IonSelect fill='outline' label='Country Code' labelPlacement='stacked' name='placePhoneCode' placeholder='Country Code' value={'+1'}>
                                            <IonSelectOption value='+1'>+1 (United States / Canada)</IonSelectOption>
                                            {countries.map((country:any, index:number) => (
                                                <IonSelectOption key={index} value={country['dial_code']}>{country['dial_code']} ({country['countries_name']})</IonSelectOption>
                                            ))}
                                        </IonSelect>
                                    </IonCol>
                                    <IonCol sizeXs='12' sizeSm='6'>
                                        <IonInput fill='outline' label='Phone Number' labelPlacement='stacked' name='placePhone' onKeyUp={formatPhone} ref={phoneInputRef} type='tel'></IonInput>  
                                    </IonCol> 
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Cellular or Internet connection is available</b></IonLabel>
                                    </IonCol>
                                    <IonCol className='ion-no-padding' sizeXs='12' sizeSm='6' sizeMd='6' sizeLg='6' sizeXl='6'>
                                        <IonSelect fill='outline' labelPlacement='stacked' name='placeConnectivity' placeholder='Select'>
                                            <IonSelectOption value='Yes'>Yes</IonSelectOption>
                                            <IonSelectOption value='No'>No</IonSelectOption> 
                                            <IonSelectOption value='Unknown'>Unknown</IonSelectOption>
                                        </IonSelect>
                                    </IonCol>
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Local Emergency Response Agencies</b></IonLabel><br />
                                        <IonNote>Include the name and phone number of the agencies your emergency contact(s) should call. This could be the local police, search and rescue team, etc.</IonNote>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonTextarea autoGrow={true} fill='outline' name='placeNotes' placeholder=''></IonTextarea>                               
                                    </IonCol>
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Other Information</b></IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonTextarea autoCapitalize='sentences' autoGrow={true} fill='outline' name='placeOtherInfo' placeholder=''></IonTextarea>                               
                                    </IonCol>
                                </IonRow>

                            </IonGrid>
                            
                            <IonButton className='ion-margin-top' color={'secondary'} expand="block" id='placeFormSubmit' type='submit'>Save</IonButton>
                        </form>
                    </IonCardContent>
                </IonCard>
                }
            </IonContent>
        </IonPage>
    );
};

export default PlaceCreate;